// React
import { useEffect } from "react";
// React Router
import { Route, Routes } from "react-router-dom";
// Pages
import { Home } from "@App/Pages/Partner/MobilityConcept/Home";
import { Garages } from "@App/Pages/Common/Garages";
import { Profile } from "@App/Pages/Common/Profile";
import { Contact } from "@App/Pages/Common/Contact";
import { Layout } from "@App/Pages/Partner/MobilityConcept/Layout";
import { Summary } from "@App/Pages/Common/Summary";
import { useSelector } from "react-redux";
import { State } from "@App/state";
import i18n from "@App/utils/i18n";
import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";
import { VehicleDelivery } from "@App/Pages/VehicleDelivery";
import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";

export function MobilityConcept() {
  const { navigateWithQuery } = useNavigateWithQueryParams();

  const organization = useSelector((state: State) => state.orders.organization);
  // change the language
  useEffect(() => {
    i18n.changeLanguage(organization.settings.language);
  }, []);

  const { config } = useOrganizationConfig();

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Layout
            logos={config.navbar.logos}
            backToPartnerButton={config.navbar.backToPartnerButton}
          />
        }
      >
        <Route
          index={true}
          element={<Home onSubmit={() => navigateWithQuery(`werkstaetten`, true)} />}
        />
        <Route
          path={"/werkstaetten"}
          element={<Garages onSubmit={() => navigateWithQuery(`../werkstatt`, true)} />}
        />
        <Route
          path={"/werkstatt"}
          element={<Profile onSubmit={() => navigateWithQuery(`buchen`, true)} />}
        />
        <Route
          path={"/werkstatt/buchen"}
          element={<Contact onSubmit={() => navigateWithQuery(`erfolgreich`, true)} />}
        />
        <Route path={"/werkstatt/buchen/erfolgreich"} element={<Summary />} />
        <Route
          path={"*"}
          element={<Home onSubmit={() => navigateWithQuery(`werkstaetten`, true)} />}
        />
      </Route>

      <Route
        path={"/"}
        element={
          <Layout
            logos={config.navbar.logos}
            backToPartnerButton={config.navbar.backToPartnerButton}
            template={"vehicleDelivery"}
          />
        }
      >
        <Route path={"fahrzeuglieferung/*"} element={<VehicleDelivery />} />
      </Route>
    </Routes>
  );
}
